import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/delay';
import { FactureModel } from '../../facture/models/facture.model';

export const FAMILLE_OPEN_EDIT = 'FAMILLE_OPEN_EDIT';
export const FAMILLE_OPEN_SHOW = 'FAMILLE_OPEN_SHOW';
export const FAMILLE_CLEAR = 'FAMILLE_CLEAR';
export const FAMILLE_CLEAR_SEARCH = 'FAMILLE_CLEAR_SEARCH';

export const FAMILLE_OPEN_EDIT_SUCCESS = 'FAMILLE_OPEN_EDIT_SUCCESS';
export const FAMILLE_OPEN_SHOW_SUCCESS = 'FAMILLE_OPEN_SHOW_SUCCESS';

export const FAMILLE_CREATE = 'FAMILLE_CREATE';
export const FAMILLE_UPDATE = 'FAMILLE_UPDATE';
export const FAMILLE_SEARCH = 'FAMILLE_SEARCH';
export const FAMILLE_DELETE = 'FAMILLE_DELETE';
export const FAMILLE_PAIEMENT_CREATE = 'FAMILLE_PAIEMENT_CREATE';
export const FAMILLE_PAIEMENT_UPDATE = 'FAMILLE_PAIEMENT_UPDATE';
export const FAMILLE_PAIEMENT_DELETE = 'FAMILLE_PAIEMENT_DELETE';
export const FAMILLE_FACTURE_CREATE = 'FAMILLE_FACTURE_CREATE';
export const FAMILLE_FACTURE_UPDATE = 'FAMILLE_FACTURE_UPDATE';
export const FAMILLE_FACTURE_DELETE = 'FAMILLE_FACTURE_DELETE';
export const FAMILLE_FACTURE_CANCEL = 'FAMILLE_FACTURE_CANCEL';
export const FAMILLE_FACTURE_CALCUL = 'FAMILLE_FACTURE_CALCUL';
export const FAMILLE_FACTURE_VALIDE = 'FAMILLE_FACTURE_VALIDE';
export const FAMILLE_FACTURES_CHARGE = 'FAMILLE_FACTURES_CHARGE';

export const FAMILLE_CREATE_SUCCESS = 'FAMILLE_CREATE_SUCCESS';
export const FAMILLE_UPDATE_SUCCESS = 'FAMILLE_UPDATE_SUCCESS';
export const FAMILLE_SEARCH_SUCCESS = 'FAMILLE_SEARCH_SUCCESS';
export const FAMILLE_DELETE_SUCCESS = 'FAMILLE_DELETE_SUCCESS';
export const FAMILLE_PAIEMENT_CREATE_SUCCESS = 'FAMILLE_PAIEMENT_CREATE_SUCCESS';
export const FAMILLE_PAIEMENT_UPDATE_SUCCESS = 'FAMILLE_PAIEMENT_UPDATE_SUCCESS';
export const FAMILLE_PAIEMENT_DELETE_SUCCESS = 'FAMILLE_PAIEMENT_DELETE_SUCCESS';
export const FAMILLE_FACTURE_CANCEL_SUCCESS = 'FAMILLE_PAIEMENT_CANCEL_SUCCESS';
export const FAMILLE_FACTURE_CREATE_SUCCESS = 'FAMILLE_FACTURE_CREATE_SUCCESS';
export const FAMILLE_FACTURE_UPDATE_SUCCESS = 'FAMILLE_FACTURE_UPDATE_SUCCESS';
export const FAMILLE_FACTURE_DELETE_SUCCESS = 'FAMILLE_FACTURE_DELETE_SUCCESS';
export const FAMILLE_FACTURE_CALCUL_SUCCESS = 'FAMILLE_FACTURE_CALCUL_SUCCESS';
export const FAMILLE_FACTURE_VALIDE_SUCCESS = 'FAMILLE_FACTURE_VALIDE_SUCCESS';
export const FAMILLE_FACTURES_CHARGE_SUCCESS = 'FAMILLE_FACTURES_CHARGE_SUCCESS';

export const FAMILLE_EDIT_ERROR = 'FAMILLE_EDIT_ERROR';
export const FAMILLE_ERROR = 'FAMILLE_ERROR';


export const noop = (data) => {};

export const FamilleActions = {
    // FAMILLE
    create: ({http, model, form, params, successCallback = noop, errorCallback = noop}) => {
        return {
            type: FAMILLE_CREATE,
            payload: {http, model, form, params, successCallback, errorCallback}
        };
    },
    update: ({http, model, form, params, successCallback = noop, errorCallback = noop}) => {
        return {
            type: FAMILLE_UPDATE,
            payload: {http, model, form, params, successCallback, errorCallback}
        };
    },
    search: ({http, model, form, params, errorCallback}) => {
        return {
            type: FAMILLE_SEARCH,
            payload: {http, model, form, params, errorCallback},
        };
    },
    delete: ({http, model, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_DELETE,
            payload: {http, model, successCallback, errorCallback},
        };
    },
    openEdit: ({http, familleModel, eleveModel, params, successCallback = noop, errorCallback = noop}) => {
        return {
            type: FAMILLE_OPEN_EDIT,
            payload: {http, familleModel, eleveModel, params, successCallback, errorCallback}
        };
    },
    clear: ({id, errorCallback}) => {
        return {
            type: FAMILLE_CLEAR,
            payload: {id, errorCallback},
        };
    },
    clearSearch: ({errorCallback}) => {
        return {
            type: FAMILLE_CLEAR_SEARCH,
            payload: {errorCallback},
        };
    },
    openShow: ({http, familleModel, eleveModel, paiementModel, factureModel, params, errorCallback}) => {
        return {
            type: FAMILLE_OPEN_SHOW,
            payload: {http, familleModel, eleveModel, paiementModel, factureModel, params, errorCallback},
        };
    },

    // PAIEMENT
    savePaiement: ({http, model, form, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_PAIEMENT_CREATE,
            payload: {http, model, form, successCallback, errorCallback},
        };
    },
    updatePaiement: ({http, model, form, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_PAIEMENT_UPDATE,
            payload: {http, model, form, successCallback, errorCallback},
        };
    },
    deletePaiement: ({http, model, params, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_PAIEMENT_DELETE,
            payload: {http, model, params, successCallback, errorCallback},
        };
    },

    // FACTURE
    calculFacture: ({http, model, familleId, params, errorCallback}) => {
        return {
            type: FAMILLE_FACTURE_CALCUL,
            payload: {http, model, familleId, params, errorCallback}
        };
    },
    createFacture: ({http, model, params, famille: {id, nom}, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_FACTURE_CREATE,
            payload: {http, model, params, famille: {id, nom}, successCallback, errorCallback}
        };
    },
    updateFacture: ({http, model, form, params, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_FACTURE_UPDATE,
            payload: {http, model, form, params, successCallback, errorCallback},
        };
    },
    deleteFacture: ({http, model, params, familleId, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_FACTURE_DELETE,
            payload: {http, model, params, familleId, successCallback, errorCallback}
        };
    },
    cancelFacture: ({http, model, params, familleId, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_FACTURE_CANCEL,
            payload: {http, model, params, familleId, successCallback, errorCallback}
        };
    },
    valideFacture: ({http, model, form, params, successCallback, errorCallback}) => {
        return {
            type: FAMILLE_FACTURE_VALIDE,
            payload: {http, model, form, params, successCallback, errorCallback},
        };
    },
    chargeFactures: ({http, factureModel, params, errorCallback}) => { // form, successCallback,
        return {
            type: FAMILLE_FACTURES_CHARGE,
            payload: {http, factureModel, params, errorCallback}, // form, successCallback,
        };
    },
};

export const FamilleEpics = [
    // FAMILLE
        // OPEN SHOW FAMILLY
        ($action, store) => {
            return $action.ofType(FAMILLE_OPEN_SHOW).mergeMap(action => {
                const {http, familleModel, eleveModel, paiementModel, factureModel, params, errorCallback} = action.payload;
                console.log('open show famille', params);
                return Observable.forkJoin(
                    familleModel.getResource('default', 'get').call(http, 'findById', params),
                    eleveModel.getResource('default', 'get').call(http, 'findByFamilleId', params),
                    paiementModel.getResource('default', 'get').call(http, 'findByFamilleId', params),
                    factureModel.getResource('default', 'get').call(http, 'selectFacturesFamille', params)
                ).map(data => {
                    const [baseFamille, eleves, paiements, factures] = data;
                    const famille: any = {
                        ...baseFamille,
                        eleves,
                        paiements,
                        factures,
                    };

                    return {
                        type: FAMILLE_OPEN_SHOW_SUCCESS,
                        payload: famille,
                    };
                })
                .catch(error => {
                    errorCallback(error);
                    return Observable.of({
                        type: FAMILLE_ERROR,
                        error,
                    });
                });
            });
        },

        // SEARCH FAMILLY
        ($action, store) => {
            return $action.ofType(FAMILLE_SEARCH).mergeMap(action => {
                const {http, model, form, params, errorCallback} = action.payload;
                let stream = null;
                if (form.controls['id'].value) {
                    stream = model.getResource('default', 'get')
                    .call(http, 'findById', params);
                } else {
                    stream = model.getResource('default', 'find')
                    .call(http, form, []);
                }
                return stream.map((data) => {
                    if (form.controls['id'].value) {
                        return {
                            type: FAMILLE_SEARCH_SUCCESS,
                            payload: [data],
                        };
                    } else {
                        return {
                            type: FAMILLE_SEARCH_SUCCESS,
                            payload: data,
                        };
                    }
                })
                .catch(error => {
                    errorCallback(error);
                    return Observable.of({
                        type: FAMILLE_ERROR,
                        error
                    });
                });
            });
        },

        // OPEN EDIT FAMILLY
        ($action, store) => {
            return $action.ofType(FAMILLE_OPEN_EDIT).mergeMap(action => {
                console.log('familleEdit action', action);
                const { http, familleModel, eleveModel, params, successCallback, errorCallback } = action.payload;
                return Observable.forkJoin(
                    familleModel.getResource('default', 'get').call(http, 'findById', params),
                    eleveModel.getResource('default', 'get').call(http, 'findByFamilleId', params),
                ).map((data) => {
                    console.log('store familleedit data', data);
                    const [famille, eleves] = data;
                    (<any>famille).eleves = eleves;
                    successCallback(famille);
                    return {
                        type: FAMILLE_OPEN_EDIT_SUCCESS,
                        payload: famille
                    };
                }).catch(error => {
                    errorCallback(error);
                    return Observable.of({
                        type: FAMILLE_ERROR,
                        error
                    });
                });
            });
        },

        // EDIT FAMILLY
        ($action, store) => {
            return $action.ofType(FAMILLE_UPDATE).mergeMap(action => {
                const {http, model, form, params, successCallback, errorCallback} = action.payload;
                // console.log("famille-update",http, model, form, params);
                return model.getResource('default', 'update')
                .call(http, form, params)
                .map(data => {
                    // console.log('EDIT FAMILLY', data);
                    if (data._explicitType == "ExceptionServeur") {
                        console.log('ExceptionServeur', data);
                        const erreur = data.message;
                        errorCallback({
                            type: 'Erreur serveur',
                            message: erreur,
                        });
                        return Observable.of({
                            type: 'Erreur serveur', //FAMILLE_ERROR,
                            message: erreur,
                            //error: {erreur},
                        });
                    }
                    const id = form.value['id'];
                    successCallback(id);
                    return {
                        type: FAMILLE_UPDATE_SUCCESS,
                        payload: {id}
                    };
                })
                .catch((error) => {
                    errorCallback(error);
                    return Observable.of({
                        type: FAMILLE_ERROR,
                        error
                    });
                });
            });
        },

        // CREATE FAMILLY
        ($action, store) => {
            return $action.ofType(FAMILLE_CREATE).mergeMap(action => {
                const { http, model, form, params, successCallback, errorCallback } = action.payload;
                return model.getResource('default', 'save').call(http, form, params)
                .map((data) => {
                    successCallback(data);
                    return {
                        type: FAMILLE_CREATE_SUCCESS,
                        payload: data
                    };
                })
                .catch((error) => {
                    errorCallback(error);
                    return Observable.of({
                        type: FAMILLE_ERROR,
                        error
                    });
                });
            });
        },

        // DELETE FAMILLY
        ($action, store) => {
            return $action.ofType(FAMILLE_DELETE).mergeMap(action => {
                const {http, model, successCallback, errorCallback} = action.payload;
                return model.getResource('default', 'delete')
                .call(http, [model])
                // .call(http, [{id: model.id, _explicitType: "Famille"}])
                .map((data) => {
                    successCallback(data);
                    if (data < 0) {
                        return {
                            type: FAMILLE_ERROR,
                        };
                    } else {
                        return {
                            type: FAMILLE_DELETE_SUCCESS,
                            payload: {id: model.id},
                        };
                    }
                })
                .catch((error) => {
                    errorCallback(error);
                    return Observable.of({
                        type: FAMILLE_ERROR,
                        error
                    });
                });
            });
        },

    // PAIEMENT
    // SAVE PAIEMENT
    ($action, store) => {
        return $action.ofType(FAMILLE_PAIEMENT_CREATE).mergeMap(action => {
            const {http, model, form, successCallback, errorCallback} = action.payload;
            return model.getResource('default', 'save').call(http, form)
            .map(data => {
                const paiement = {...form.value, id: data};
                successCallback(paiement);
                return {
                    type: FAMILLE_PAIEMENT_CREATE_SUCCESS,
                    payload: paiement,
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },

    // UPDATE PAIEMENT
    ($action, store) => {
        return $action.ofType(FAMILLE_PAIEMENT_UPDATE).mergeMap(action => {
            const {http, model, form, successCallback, errorCallback} = action.payload;
            return model.getResource('default', 'update')
            .call(http, form, [])
            .map(data => {
                const paiement = {...form.value, id: data};
                successCallback(paiement);
                return {
                    type: FAMILLE_PAIEMENT_UPDATE_SUCCESS,
                    payload: paiement,
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },

    // DELETE PAIEMENT
    ($action, store) => {
        return $action.ofType(FAMILLE_PAIEMENT_DELETE).mergeMap(action => {
            const {http, model, params, successCallback, errorCallback} = action.payload;
            return model.getResource('default', 'delete')
            .call(http, params)
            .map(data => {
                successCallback(data);
                return {
                    type: FAMILLE_PAIEMENT_DELETE_SUCCESS,
                    payload: {id: data, familleId: model.famille.id},
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },


    // FACTURE
    // CALCUL FACTURE
    ($action, store) => {
        return $action.ofType(FAMILLE_FACTURE_CALCUL).mergeMap(action => {
            const {http, model, familleId, params, errorCallback} = action.payload;
            return model.getResource('default', 'get')
            .call(http, 'genereFactureFamille', params)
            .switchMap((data) => {
                console.log(data);
                if (data['_explicitType'] === 'ExceptionServeur') {
                    const typeToast = data.type === 'info' ? 'info' : 'erreur';
                    throw new Error(`${data.message}`); 
                  }
                // Call api to get lignesFacture as previous call doesnt return lignesFacture
                return model.getResource('default', 'get')
                .call(http, 'selectFacturesFamille', params);
            })
            .map((data) => {
                // successCallback(data);
                return {
                    type: FAMILLE_FACTURE_CALCUL_SUCCESS,
                    payload: {familleId, factures: data}
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },

    // CREATE FACTURE
    ($action, store) => {
        return $action.ofType(FAMILLE_FACTURE_CREATE).mergeMap(action => {
            const {http, model, params, famille, successCallback, errorCallback} = action.payload;
            return model.getResource('default', 'get')
            .call(http, 'createFactureFamille', params)
            .map((data: any) => {
                data = {...data, idFamille: famille.id, familleNom: famille.nom};
                console.log('createFactureFamille', {data});
                // successCallback(data);
                return {
                    type: FAMILLE_FACTURE_CREATE_SUCCESS,
                    payload: data
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },

    // UPDATE FACTURE
    ($action, store) => {
        return $action.ofType(FAMILLE_FACTURE_UPDATE).mergeMap(action => {
            const {http, model, form, params, successCallback, errorCallback} = action.payload;
            return model.getResource('default', 'post')
            .call(http, 'saveFacture', form, params)
            .map((data) => {
                successCallback(data);
                return {
                    type: FAMILLE_FACTURE_UPDATE_SUCCESS,
                    payload: data,
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },

    // DELETE FACTURE
    ($action, store) => {
        return $action.ofType(FAMILLE_FACTURE_DELETE).mergeMap(action => {
            const {http, model, params, familleId, successCallback, errorCallback} = action.payload;
            return model.getResource('default', 'get')
            .call(http, 'deleteFacture', params)
            .map((data) => {
                successCallback(data);
                return {
                    type: FAMILLE_FACTURE_DELETE_SUCCESS,
                    payload: {id: data, familleId}
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },

    // CANCEL FACTURE
    ($action, store) => {
        return $action.ofType(FAMILLE_FACTURE_CANCEL).mergeMap(action => {
            const {http, model, params, familleId, successCallback, errorCallback} = action.payload;
            console.log('FAMILLE_FACTURE_CANCEL', params); // [idFactureAAnnuler]
            return model.getResource('default', 'get')
            .call(http, 'annuleFactureValidee', params)
            .map((data) => { // data est la facture d'annulation
                console.log('annuleFactureValidee', data);
                successCallback(data);
                return {
                    type: FAMILLE_FACTURE_CANCEL_SUCCESS,
                    payload: data,
                    http: http,
                    errorCallback: errorCallback,
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },

    // VALIDE FACTURE
    ($action, store) => {
        return $action.ofType(FAMILLE_FACTURE_VALIDE).mergeMap(action => {
            const {http, model, form, params, successCallback, errorCallback} = action.payload;
            console.log('Validation facture', params);
            return model.getResource('default', 'post')
            .call(http, 'valide', form, params)
            .map((data) => { // data est une facture
                console.log('valide facture', data);
                successCallback(data);
                return {
                    type: FAMILLE_FACTURE_VALIDE_SUCCESS,
                    payload: data,
                    http: http,
                    errorCallback: errorCallback,
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },

    // VALIDE FACTURE SUCCESS => Charger les factures
    ($action, store) => {
        return $action.ofType(FAMILLE_FACTURE_VALIDE_SUCCESS, FAMILLE_FACTURE_CANCEL_SUCCESS).mergeMap(action => {
            console.log('FAMILLE_FACTURE_VALIDE_SUCCESS', action.payload, action.http);
            const factureAvantValidation = action.payload;
            const factureModel = new FactureModel(factureAvantValidation);
            // params doit contenir idFamille et idAnneeScolaire
            const params = [factureAvantValidation.idFamille, factureAvantValidation.anneeScolaire];
            return Observable.of(FamilleActions.chargeFactures({
                http: action.http,
                factureModel: factureModel,
                params: params,
                errorCallback: action.errorCallback,
            }));
        });
    },

    // FACTURES CHARGE
    ($action, store) => {
        return $action.ofType(FAMILLE_FACTURES_CHARGE).mergeMap(action => {
            const {http, factureModel, params, errorCallback} = action.payload;
            console.log('Charge factures', params);
            return factureModel.getResource('default', 'get')
            .call(http, 'selectFacturesFamille', params) // params doit contenir idFamille et idAnneeScolaire
            .map((data: any) => {
                console.log('selectFacturesFamille resultat', data); // data est un tableau contenant la facture validée
                data = {factures: data, idFamille: factureModel.idFamille};
                console.log('selectFacturesFamille', data);
                return {
                    type: FAMILLE_FACTURES_CHARGE_SUCCESS,
                    payload: data,
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: FAMILLE_ERROR,
                    error,
                });
            });
        });
    },



];

const initialState = {
    list: null,
    show: null,
    edit: null,
    loading: false,
    paiementLoading: false,
    factureLoading: false,
    searchForm: null,
};

export const FamilleReducer = (state = initialState, action: any) => {
    // console.log('FamilleReducer', {action});

    let familleId = null;

    switch (action.type) {
        case FAMILLE_SEARCH:
                return {...state,
                    loading: true,
                    searchForm: action.payload.form,
                };
        case FAMILLE_CREATE:
        case FAMILLE_OPEN_EDIT:
        case FAMILLE_OPEN_SHOW:
        case FAMILLE_DELETE:
            return {...state, loading: true};
        case FAMILLE_CLEAR:
            return {...state,
                loading: false,
                edit: {...state.edit, [action.payload.id]: null},
                show: {...state.show, [action.payload.id]: null},

            };
        case FAMILLE_CLEAR_SEARCH:
            return {...state,
                loading: false,
                searchForm: null,
                list: null,
            };
        case FAMILLE_PAIEMENT_CREATE:
        case FAMILLE_PAIEMENT_UPDATE:
        case FAMILLE_PAIEMENT_DELETE:
            return {...state, paiementLoading: true};

        case FAMILLE_FACTURE_CREATE:
        case FAMILLE_FACTURE_UPDATE:
        case FAMILLE_FACTURE_VALIDE:
        case FAMILLE_FACTURE_DELETE:
            return {...state, factureLoading: true};

        case FAMILLE_CREATE_SUCCESS:
            return {...state, loading: false};

        case FAMILLE_SEARCH_SUCCESS:
            return {...state, list: action.payload, loading: false };
        case FAMILLE_DELETE_SUCCESS:
            return {...state,
                loading: false,
                list: state.list ? state.list.filter(famille => famille.id !== action.payload.id) : null,
                show: {...state.show, [action.payload.id]: null},
                edit: {...state.edit, [action.payload.id]: null},
            };

        case FAMILLE_OPEN_SHOW_SUCCESS:
            return {...state, show: {...state.show, [action.payload.id]: action.payload}, loading: false };
        case FAMILLE_OPEN_EDIT_SUCCESS:
            return {...state, edit: {...state.edit, [action.payload.id]: action.payload}, loading: false };

        case FAMILLE_UPDATE_SUCCESS:
            // Reset cache so that we force reload
            return {...state,
                loading: false,
                edit: {...state.edit, [action.payload.id]: null},
                show: {...state.show, [action.payload.id]: null}
            };

        case FAMILLE_FACTURE_CALCUL_SUCCESS:
            familleId = action.payload.familleId;
            return {...state,
                factureLoading: false,
                show: {...state.show, [familleId]: {
                    ...state.show[familleId],
                    factures: action.payload.factures
                }}
            };
        case FAMILLE_FACTURE_CREATE_SUCCESS:
            familleId = action.payload.idFamille;
            return {...state,
                factureLoading: false,
                show: {...state.show, [familleId]: {
                    ...state.show[familleId],
                    factures: [...state.show[familleId].factures, action.payload]
                }}
            };

        case FAMILLE_FACTURES_CHARGE_SUCCESS:
            familleId = action.payload.idFamille;
            return {...state,
                factureLoading: false,
                show: {...state.show, [familleId]: {
                    ...state.show[familleId],
                    factures: action.payload.factures
                }}
            };

        case FAMILLE_FACTURE_UPDATE_SUCCESS:
        // case FAMILLE_FACTURE_CANCEL_SUCCESS:
        case FAMILLE_FACTURE_VALIDE_SUCCESS:
            familleId = action.payload.idFamille;
            console.log('update ou valide success', action.payload);
            // Comment forcer le rechargement de la facture ?
            return {...state,
                factureLoading: false,
                show: {...state.show, [familleId]: {
                    ...state.show[familleId],
                    factures: /*null*/
                        state.show[familleId].factures.map(facture => {
                            return +facture.id === +action.payload.id ? action.payload : facture;
                        }) 
                }}
            };

        case FAMILLE_FACTURE_DELETE_SUCCESS:
            familleId = action.payload.familleId;
            return {...state,
                factureLoading: false,
                show: {...state.show, [familleId]: {
                    ...state.show[familleId],
                    factures: state.show[familleId].factures.filter(facture => facture.id !== action.payload.id)
                }}
            };

        case FAMILLE_PAIEMENT_CREATE_SUCCESS:
            familleId = action.payload.famille.id;
            return {...state, paiementLoading: false, show: {...state.show, [familleId]: {
                ...state.show[familleId],
                paiements: [...state.show[familleId].paiements, action.payload]
            }}};
        case FAMILLE_PAIEMENT_UPDATE_SUCCESS:
            familleId = action.payload.famille.id;
            return {...state, paiementLoading: false, show: {...state.show, [familleId]: {
                ...state.show[familleId],
                paiements: state.show[familleId].paiements.map(paiement => {
                    return paiement.id === action.payload.id ? action.payload : paiement;
                })
            }}};
        case FAMILLE_PAIEMENT_DELETE_SUCCESS:
            familleId = action.payload.familleId;
            return {...state, paiementLoading: false, show: {...state.show, [familleId]: {
                ...state.show[familleId],
                paiements: state.show[familleId].paiements.filter(paiement => paiement.id !== action.payload.id)
            }}};


        case FAMILLE_ERROR:
            return {...state, loading: false, paiementLoading: false};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/famille/models/famille.store.ts